import moduleEnv from '@/constants/env'

export const getLoginHref = (redirectUrl?: 'checkout' | string) => {
  const loginPath = '/account/login'
  if (!redirectUrl) return loginPath

  if (redirectUrl === 'checkout') {
    return `${loginPath}?redirect_url=checkout`
  }

  const redirectUrlObject = new URL(redirectUrl, moduleEnv.SITE)

  if (redirectUrlObject.pathname === '/') {
    return loginPath
  }

  return `${loginPath}?redirect_url=${redirectUrlObject.pathname}${redirectUrlObject.search}`
}
